module.exports = __webpack_public_path__ + "img/img_app_bnr_01_feature1.c63cba88.png";